import { useQuery } from '@tanstack/react-query';
import { getLearners } from '../api/learners';
import { useAuthStore } from '../stores/authStore';

// FP-LEARNER-STORE-RETIREMENT-01: list of the parent's learners. React Query
// is the single source of truth — no Zustand persist shadow. Modeled on
// useMe / useAccess: 30s staleTime, refetch on window focus and reconnect so
// settings/curriculum changes made elsewhere flow back without manual sync.
export function useLearners() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  return useQuery({
    queryKey: ['learners'],
    queryFn: async () => {
      const data = await getLearners();
      return data.learners || data || [];
    },
    enabled: isAuthenticated,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });
}
